angular.module('qkr').filter('outletContactDetails', ['$filter', 'utils', function($filter, utils) {
  return function(outlets, selectedState, selectedCity, searchText) {
	  return $filter('filter')(outlets, (outlet) => {
		  // Default to true if no value supplied for search
		  let matchedState = utils.hasNoValue(selectedState);
		  let matchedCity = utils.hasNoValue(selectedCity);
		  let matchedSearch = utils.hasNoValue(searchText);
		  
		  if (!utils.hasNoValue(selectedState)) {
			  if (outlet.contactDetails && outlet.contactDetails.state === selectedState) {
				  matchedState = true;
			  }
		  }
		  
		  if (matchedState && !utils.hasNoValue(selectedCity)) {
			  if (outlet.contactDetails && outlet.contactDetails.city === selectedCity) {
				  matchedCity = true;
			  }
		  }
		  
		  if (matchedState && matchedCity && !utils.hasNoValue(searchText)) {
			  if (_.contains(outlet.name.toUpperCase(), searchText.toUpperCase())) {
			  	matchedSearch = true;
			  }			  else {
                  switch (searchText.toUpperCase()) {
                      case outlet.contactDetails.state.toUpperCase().substring(0, searchText.length):
                          matchedSearch = true;
                          break;
                      case outlet.contactDetails.addressLine1.toUpperCase().substring(0, searchText.length):
                          matchedSearch = true;
                          break;
                      case outlet.contactDetails.city.toUpperCase().substring(0, searchText.length):
                          matchedSearch = true;
                          break;
                      default:
                          matchedSearch = false;
                  }
              }
		  }
		  
		  return (matchedState && matchedCity && matchedSearch);
	  });
  };
}]);



// WEBPACK FOOTER //
// ./src/filters/outlet_contact_details.js